import styled from '@emotion/styled'
import { Theme } from '@mui/material'
import { SxProps } from '@mui/system'
import { match } from 'ts-pattern'
import { theme } from 'styles/theme'

export interface PhoneLocalMenuItemContainerProps {
  variant?: 'VALUE' | 'MENU_ITEM' | 'IMPORT'
}

export const PhoneLocalMenuItemContainer = styled.div<PhoneLocalMenuItemContainerProps>`
  height: 34px;
  ${({ variant }) =>
    match(variant)
      .with('MENU_ITEM', () => 'width: 80px')
      .with('IMPORT', () => 'width: 50px')
      .otherwise(() => 'width: 60px')};
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  font-size: 12px;
`

export const PhoneNumberSelectSXProps = {
  height: '44px',
  padding: '0 8px 0',
  borderRadius: '12px 0px 0px 12px',
  backgroundColor: theme.palette.surface.default,
  '& .MuiOutlinedInput-notchedOutline': {
    paddingTop: '20px',
    border: `1px solid ${theme.palette.surface.secondary}`
  }
}

export const CountryCodeContainer = styled.p`
  width: 50%;
  font-size: 12px;
  margin: 0;
`

export const CountryFlagStyle = {
  transform: 'scale(0.5)',
  width: '45px'
}

export const PhoneNumberInputStyle = {
  borderRadius: '0px 12px 12px 0px'
}

export const sxInputProps: SxProps<Theme> = { padding: '0 !important' }
export const sxPaperProps: SxProps<Theme> = { maxHeight: 210 }
